import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ContentBox from "../../../../../components/ui/ContentBox";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import Pagination from "../../../../../components/ui/Pagination";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import OverflowText from "../../../../../components/ui/Textoverflow";

import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";
import EndpointsFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/EndpointFilter";

import { plusIcon, minusIcon, searchIcon, showScreenshotIcon } from "../../../../../utils/icons";
import { formatDate } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getRansomewareGroup, getRansomweregroupData } from "../../../../../store/actions/scanInfoAction";

const RansomewareGroup = () => {

    const ransomwareGroupListResponse = useSelector((state) => state.scanInfo?.ransomwareGroupListList);
    const ransomwereGroupDataResponse = useSelector((state) => state.scanInfo?.ransomwereGroupData);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const [activeContent, setActiveContent] = useState("affectedEndpoints");
    const [selectedRansomware, setSelectedRansomware] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isEndpointLoading, setIsEndpointLoading] = useState(false);
    const [showScreenshotModal, setShowScreenshotModal] = useState(false);
    const [screenShotSrc, setScreenShotSrc] = useState("");
    const [scanNotFound, setScanNotFound] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [listCurrentPage, setListCurrentPage] = useState(1);

    //list search state
    const [listSearch, setListSearch] = useState("");
    const [updatedListSearchValue, setUpdatedListSearchValue] = useState("");

    //affected endpoint search state
    const [endpointSearch, setEndpointSearch] = useState("");
    const [endpointsQuery, setEndpointsQuery] = useState("");
    const [endpointSearchFocused, setEndpointSearchFocused] = useState(false);

    //selected list filter
    const [listFilterValue, setListFilterValue] = useState({});

    //endpoint filter
    const [endpointFiltersValue, setEndpointFiltersValue] = useState({})

    const handlePageChange = (newPage) => {
        setListCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true);
    };

    const showContent = (data) => {  
        if(activeContent === data) {
            setActiveContent("")
        } else {
            setActiveContent(data)
            if(data === "affectedEndpoints") {
                fetchAffectedEndPoints()
            }
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && endpointSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setEndpointsQuery(endpointSearch)
    }

    const listFilterApply = (data) => {
        setListCurrentPage(1)
        setListFilterValue(data);
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setListCurrentPage(1);
        setListFilterValue({})
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const endPointFilterApply = (data) => {
        setEndpointFiltersValue(data)
    }

    const isAnyEndpointFilterActive = Object.values(endpointFiltersValue).some(value => Boolean(value));

    const resetEndpointFilterValue = () => {
        setCurrentPage(1)
        setEndpointFiltersValue({})
    }

    const fetchAffectedEndPoints = useCallback(()=>{
        setIsEndpointLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedRansomware?.domain}&scan_id=${selectedRansomware?.scan_id}&result_id=${selectedRansomware?.id}`;
        const queryParams = endpointsQuery ? `&query=${endpointsQuery}` : "";
        const newFindings = endpointFiltersValue?.newFindings?.value && endpointFiltersValue?.newFindings?.value !== "all" ? `&new_record=${endpointFiltersValue?.newFindings?.value === "yes" ? true : false}` : "";
        const url = `${baseUrl}${queryParams}${newFindings}`
        dispatch(getRansomweregroupData(url))
    },[dispatch, currentPage, currentPageSize, selectedRansomware, endpointsQuery, endpointFiltersValue])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedListSearchValue(searchTerm)
    }, 500), []);

    const fetchRansomwareList = useCallback(()=>{
        setIsLoading(true);
        setScanNotFound(false)
        const baseUrl = `&page=${listCurrentPage}&page_size=10`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedListSearchValue ? `&query=${updatedListSearchValue}` : "";
        const newFindings = listFilterValue?.newFindings?.value && listFilterValue?.newFindings?.value !== "all" ? `&new_record=${listFilterValue?.newFindings?.value === "yes" ? true : false}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        dispatch(getRansomewareGroup(url))
    },[dispatch, domainId, scanId, organizationId, listCurrentPage, updatedListSearchValue, listFilterValue])

    useEffect(() => {
        if (selectedRansomware) {
            setCurrentPage(1);
        }
    }, [selectedRansomware]);

    useEffect(()=>{
        if(selectedRansomware?.id) {
            setCurrentPage(1);
            fetchAffectedEndPoints()
        }        
    },[currentPage, selectedRansomware, fetchAffectedEndPoints])

    useEffect(() => {
        if (triggerListFetch) {
            fetchRansomwareList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchRansomwareList]);

    useEffect(() => {
        setListCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedListSearchValue]);

    useEffect(()=>{
        if(ransomwareGroupListResponse !== null) {
            if(ransomwareGroupListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(ransomwareGroupListResponse?.results?.length > 0) {                
                setSelectedRansomware(ransomwareGroupListResponse?.results[0]);
            }
            setIsLoading(false)
        }
    },[ransomwareGroupListResponse])

    useEffect(() => {
        if(ransomwereGroupDataResponse !== null) {
            setIsEndpointLoading(false)
        }
    },[ransomwereGroupDataResponse])


    return (
        <>
            <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>Ransomware Group List</h1>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                    <ListFilter listFilterApply={listFilterApply} listFilterValue={listFilterValue} currentPage={"ransomwareGroup"} />
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input"
                                        value={listSearch}
                                        onChange={(e)=>{                                            
                                            setListSearch(e.target.value);
                                            requestSearch(e.target.value);
                                            setListCurrentPage(1);
                                            setContextCurrentPage(1);
                                            setTriggerListFetch(true);
                                        }}
                                    />
                                </div>
                                <div className="list-main-container">
                                    { !isLoading && scanNotFound &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={ransomwareGroupListResponse?.description}/>
                                        </motion.div>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                        <SkeletonLoader type={"line"} count={5} currentPage={"ransomwereGroup"} />
                                        :
                                        (
                                            ransomwareGroupListResponse?.results?.length > 0 &&
                                            ransomwareGroupListResponse?.results?.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${selectedRansomware?.id === data?.id ? "active" : ""}`} key={index} onClick={()=>{setSelectedRansomware(data)}}>
                                                            <div className={`d-flex align-items-center subdomain-name gap-2 mb-2 ${!data?.new_record ? "full-width" : ""}`}>
                                                                <OverflowText text={data?.group_name} className={"sub-domain-heading"}/>
                                                                {data.new_record && <span className="new-subdomain">New</span>}
                                                            </div>
                                                            <p className="sub-domain-name">{data?.domain}</p>
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && ransomwareGroupListResponse?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={ransomwareGroupListResponse?.meta?.total_results}
                                            currentPage={listCurrentPage}
                                            onPageChange={handlePageChange}
                                        />
                                    }
                                    { !isLoading && ransomwareGroupListResponse?.results?.length === 0 &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Data Found"} />
                                        </motion.div>
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="main-content bg-white-with-shadow p-2 h-100">
                                {
                                    !isLoading && scanNotFound ?
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={ransomwareGroupListResponse?.description}/>
                                        </motion.div>
                                    :
                                    (
                                        !isLoading && ransomwareGroupListResponse?.results?.length === 0 ?
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <NoDataFound noDataText={"No Data Found"}/>
                                            </motion.div>
                                        :
                                        <>
                                            <div className="record-container-content p-2">
                                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("jsSecretsSummary")}}>
                                                    <h2 className="heading">Group Summary</h2>
                                                    {activeContent === "jsSecretsSummary" ? minusIcon() : plusIcon()}
                                                </div>
                                                {
                                                    isLoading && activeContent === "jsSecretsSummary" ?
                                                        <SkeletonLoader type={"line"} count={5} currentPage={"sensitiveExpo"} />
                                                    :
                                                    <>
                                                        {activeContent === "jsSecretsSummary" && <div className="js-secrete-summary mt-3">
                                                            <motion.div
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4 }}
                                                            >
                                                                <Row>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Group Name"} value={selectedRansomware?.group_name}/>
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Group Description"} value={selectedRansomware?.group_description}/>
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Group Link"} value={selectedRansomware?.group_url}/>
                                                                    </Col>
                                                                </Row>
                                                            </motion.div>
                                                        </div> }
                                                    </>
                                                }                                                                   
                                            </div>
                                            <div className="record-container-content p-2 mt-3">
                                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("affectedEndpoints")}}>
                                                    <h2 className="heading">Leaked Data</h2>
                                                    {activeContent === "affectedEndpoints" ? minusIcon() : plusIcon()}
                                                </div>
                                                {activeContent === "affectedEndpoints" && <div className="affected-endpoint-container">
                                                    <div className="git-leaks-main-content">
                                                        <div className="search-header-container d-flex align-items-center gap-3 my-3">
                                                            <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                                                <div className="search-container position-relative">
                                                                    <span className="position-absolute">{searchIcon()}</span>
                                                                    <input type="text" 
                                                                        placeholder="Search" 
                                                                        value={endpointSearch} 
                                                                        onChange={(e)=>{
                                                                            setEndpointSearch(e.target.value)
                                                                        }}
                                                                        onFocus={() => setEndpointSearchFocused(true)}
                                                                        onBlur={() => setEndpointSearchFocused(false)}
                                                                    />
                                                                </div>
                                                                <button className="search-btn" onClick={onSearch}>Search</button>
                                                            </div>
                                                            <EndpointsFilter endPointFilterApply={endPointFilterApply} endpointFiltersValue={endpointFiltersValue} currentPage={"botnetLeaks"} />
                                                            {isAnyEndpointFilterActive && (<span className="reset-filter-link" onClick={resetEndpointFilterValue}>Reset Filter</span>)}
                                                        </div>
                                                        <div className="js-secrets-table ransomware-group-table">
                                                            {
                                                                isEndpointLoading ?
                                                                <SkeletonLoader type={"line"} count={5} currentPage={"ransomwereGroup"} />
                                                                :
                                                                <Table responsive="lg">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Details</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            ransomwereGroupDataResponse?.results?.length > 0 &&
                                                                            ransomwereGroupDataResponse?.results?.map((data, index) => {
                                                                                return (
                                                                                    <motion.tr
                                                                                        key={index}
                                                                                        initial={{ opacity: 0, y: 20 }}
                                                                                        animate={{ opacity: 1, y: 0 }}
                                                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                                    >
                                                                                        <td className="leak-details">
                                                                                            <div className="d-flex justify-content-between">
                                                                                                <div>
                                                                                                    {!data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                                                                    <p className="heading-text mb-2">Leak Title/Domain:</p>
                                                                                                    <span className="details">{data?.leak_title}</span> - <span className="details">{data?.leak_domain}</span> {data?.leak_published ? <span className="published">Published</span> : <span className="published">DeadLine - {formatDate(data?.leak_deadline, "date")}</span>}

                                                                                                    <p className="heading-text mb-2">Leak Date:</p>
                                                                                                    <span className="details">{formatDate(data?.leak_date, "date")}</span>                                                                                        
                                                                                                </div>
                                                                                                <div className="screenshot-image">
                                                                                                    <p className="overlay" onClick={()=>{
                                                                                                        setScreenShotSrc(data?.leak_screenshot)
                                                                                                        setShowScreenshotModal(true);
                                                                                                    }}>
                                                                                                        <span>{showScreenshotIcon()}</span>
                                                                                                    </p>
                                                                                                    <img src={data?.leak_screenshot} alt="screenshot" />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div>
                                                                                                <p className="heading-text my-2">Description:</p>
                                                                                                <span className="details">{data?.leak_description}</span>

                                                                                                <p className="heading-text my-2">Post Url</p>
                                                                                                <a className="text-overflow table-url" href={data?.leak_post_url} target="_blank"  rel="noreferrer">{data?.leak_post_url}</a>

                                                                                                <p className="heading-text my-2">Leak download Link</p>
                                                                                                <a className="text-overflow table-url" href={data?.leak_download_url} target="_blank"  rel="noreferrer">{data?.leak_download_url}</a>
                                                                                            </div> 
                                                                                        </td>
                                                                                    </motion.tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                            {
                                                                !isEndpointLoading && ransomwereGroupDataResponse !== "" && ransomwereGroupDataResponse?.results?.length === 0 && 
                                                                <motion.div
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4 }}
                                                                >
                                                                    <NoDataFound noDataText={"No Record Found"}/>
                                                                </motion.div>
                                                            }
                                                            {ransomwereGroupDataResponse !== "" && ransomwereGroupDataResponse?.results?.length > 0 && <Pagination
                                                                className="pagination-bar"
                                                                currentPage={currentPage}
                                                                pageSize={currentPageSize}
                                                                totalCount={ransomwereGroupDataResponse?.meta?.total_results}
                                                                onPageChange={setCurrentPageandRecordSize}
                                                            />}
                                                            
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        </>
                                    )
                                }
                                
                                <Modal
                                    show={showScreenshotModal}
                                    onHide={()=>setShowScreenshotModal(false)}
                                    size="lg"
                                    centered
                                    className=""
                                    >
                                        <Modal.Body>                                
                                            <div className="Screenshot-modal-container">
                                                <div className="p-4 m-2">
                                                    <img src={screenShotSrc} alt="screenshot" />
                                                </div>
                                            </div>
                                        </Modal.Body>
                                </Modal>
                            </div>
                        </Col>
                    </Row>
                </div>
        </>        
    )
}


export default RansomewareGroup;